
export interface SubcategoryInterface {
    id: string,
    name: string,
    icon: string,
    categoryId: string,
    headerImageUrl: string,
    tagline: string,
}

export class Subcategory implements SubcategoryInterface {
    id: string;
    name: string;
    icon: string;
    categoryId: string;
    headerImageUrl: string;
    tagline: string;

    constructor(jsonData: any) {
        this.id = jsonData._id
        this.name = jsonData.name
        this.icon = jsonData.icon
        this.categoryId = jsonData.category
        this.headerImageUrl = jsonData.headerImageUrl
        this.tagline = jsonData.tagline
    }

}
